const BASE = "https://lqx2gj6cwj.execute-api.eu-west-1.amazonaws.com/api/";

const api = async (path, params = "") => {
  try {
    const response = await fetch(`${BASE}${path}${params}`);

    if (response.ok) {
      return response.json();
    } else {
      throw new Error("request failed");
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const getJobs = async () => {
  let concatenatedJobs = [];
  let data;
  let nextSinceId;
  do {
    nextSinceId = data ? new URL(data.paging?.next).searchParams.get("since_id") : "";
    data = await api("jobs", `?since_id=${nextSinceId || ""}`);
    concatenatedJobs = concatenatedJobs.concat(data.jobs);
  } while (data.paging);

  return concatenatedJobs;
};

export const getJob = async (shortcode) => {
  const job = await api(`jobs/${shortcode}`);

  return job;
};



// WEBPACK FOOTER //
// ./lib/workable.js